(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.droopler_subtheme = {
    attach: function (context, settings) {

      // Insert your code here.

    }
  };

})(jQuery, Drupal);
